import {cloneDeep, merge} from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {Button, Modal} from 'semantic-ui-react';
import CustomiseCoverPageDetailsForm from './CustomiseCoverPageDetailsForm';

const DefaultState = {
	open: false,
	sectionData: {},
};

class CustomiseCoverPageDetailsModal extends Component {
	static propTypes = {
		sectionData: PropTypes.object,
		onSave: PropTypes.func,
	};

	constructor(props, context) {
		super(props, context);
		this.state = cloneDeep(DefaultState);
	}

	close = () => this.setState({ open: false });
	open = () => {
		this.setState({
			...cloneDeep(DefaultState),
			open: true,
		});
	};

	addEvent = (e, change) => {
		const {name, value} = change;

		let sectionData = {};
		sectionData[name] = value;

		this.setState({
			sectionData: {
				...this.state.sectionData,
				...sectionData
			}
		});
	};

	saveAndClose = () => {
		this.props.onSave({
			sectionData: this.state.sectionData,
		});
		this.close();
	};

	render() {
		const { sectionData: storedData } = this.props;
		const { open, sectionData: updatedData } = this.state;

		const sectionData = merge(cloneDeep(storedData), cloneDeep(updatedData));

		return (
				<Modal
					open={open}
					closeOnEscape
					closeOnDimmerClick={false}
					onClose={this.close}
					trigger={<Button id="cover-details-trigger" primary onClick={this.open}>Edit Details</Button>}
				>
					<Modal.Header>Edit Cover Details</Modal.Header>
					<Modal.Content scrolling>
						<CustomiseCoverPageDetailsForm sectionData={sectionData} onChange={this.addEvent}/>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={this.close}>
							Cancel
						</Button>
						<Button onClick={this.saveAndClose} primary>
							Save
						</Button>
					</Modal.Actions>
				</Modal>
		);
	}
}

export default CustomiseCoverPageDetailsModal;